export default __webpack_public_path__ + "static/media/Review.c35bd671.svg";